import style from './List.css';
import RadioButton from '../RadioButton/RadioButton';
import CheckBox from '../CheckBox/CheckBox';
import Switch from '../Switch/Switch';
import ChevronRightSmallIcon from '../Icons/ChevronRightSmallIcon';
import { _className } from '../../../utils/classname.utils';
import { renderIf } from '../../../utils/render.utils';
import ExternalLinkIcon from '../Icons/ExternalLinkIcon';

const ListItemType = {
  BUTTON: 'button',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  SWITCH: 'switch',
  EXTERNAL: 'external',
};
const ListItemSize = {
  SMALL: 'small',
  LARGE: 'large',
};
export default function ListItem({
  className = '',
  icon,
  iconStyle = {},
  title = '',
  subtitle = '',
  infoText = '',
  actionable = false,
  disabled = false,
  selected = false,
  type = ListItemType.BUTTON,
  size = ListItemSize.SMALL,
  infoTextClassName = '',
  titleClassName = '',
  subtitleClassName = '',
  actionProps = {},
  testData = {},
  ...props
}) {
  const actions = {
    button: (
      <ChevronRightSmallIcon
        className={`${_className(disabled, style['action-disabled'])} ${
          style['forward-icon']
        }`}
        width={12}
        height={12}
        {...actionProps}
      />
    ),
    external: (
      <ExternalLinkIcon
        className={`${_className(disabled, style['action-disabled'])}`}
        width={20}
        height={20}
        {...actionProps}
      />
    ),
    radio: (
      <RadioButton disabled={disabled} checked={selected} {...actionProps} />
    ),
    checkbox: (
      <CheckBox disabled={disabled} checked={selected} {...actionProps} />
    ),
    switch: <Switch disabled={disabled} checked={selected} {...actionProps} />,
  };

  const {
    itemTestId = 'item',
    titleTestId = 'title',
    subtitleTestId = 'subtitle',
    iconTestId = 'icon',
    infoTestId = 'info',
  } = testData;

  return (
    <div
      className={`${className} ${style['list-item']} ${_className(
        disabled,
        style.disabled,
      )} ${_className(selected, style.selected)} ${style[size]}`}
      data-testid={itemTestId}
      {...props}
    >
      {renderIf(
        icon,
        <span className={style.icon} style={iconStyle} data-testid={iconTestId}>
          {icon}
        </span>,
      )}
      <div className={style.content}>
        <div className={style['title-container']}>
          <span
            className={`${style.title} ${titleClassName}`}
            data-testid={titleTestId}
          >
            {title}
          </span>
          {renderIf(
            !!infoText,
            <span
              className={`${style.info} ${infoTextClassName}`}
              data-testid={infoTestId}
            >
              {infoText}
            </span>,
          )}
        </div>
        {renderIf(
          subtitle,
          <span
            className={`${style.subtitle} ${subtitleClassName}`}
            data-testid={subtitleTestId}
          >
            {subtitle}
          </span>,
        )}
      </div>
      {renderIf(
        actionable,
        <div className={style.action}>{actions[type]}</div>,
      )}
    </div>
  );
}

ListItem.Type = ListItemType;
ListItem.Size = ListItemSize;
